import axios from 'axios';
import { firebaseAuth } from '../firebase';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export async function getAuthBearerToken() {
  if (!firebaseAuth?.currentUser) return null;
  try {
    return await firebaseAuth.currentUser.getIdToken();
  } catch {
    return null;
  }
}

function attachFirebaseAuthInterceptor(instance) {
  instance.interceptors.request.use(
    async (config) => {
      const headers = config.headers || {};
      // Ne pas écraser un Bearer déjà fourni (ex. jeton frais après inscription).
      if (headers.Authorization || headers.authorization) {
        return config;
      }
      const idToken = await getAuthBearerToken();
      if (idToken) {
        config.headers.Authorization = `Bearer ${idToken}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
}

function attachNetworkErrorInterceptor(instance) {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.code === 'ECONNABORTED') {
        console.error('Timeout: La requête a pris trop de temps');
        return Promise.reject(new Error('La requête a pris trop de temps. Vérifiez votre connexion.'));
      }
      if (error.message === 'Network Error' || error.code === 'ERR_NETWORK' || error.code === 'ERR_FAILED') {
        console.error('Erreur réseau: Impossible de se connecter au serveur');
        console.error('URL de l\'API:', API_URL);
        return Promise.reject(
          new Error(`Impossible de se connecter au serveur sur ${API_URL}. Vérifiez que le serveur backend est démarré.`)
        );
      }
      return Promise.reject(error);
    }
  );
}

function createClient(options = {}) {
  const instance = axios.create({
    baseURL: API_URL,
    ...options,
  });
  attachFirebaseAuthInterceptor(instance);
  attachNetworkErrorInterceptor(instance);
  return instance;
}

/** Requêtes JSON métier (timeout 10 s par défaut). */
export const apiClient = createClient({
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000,
});

/** Paiements Stripe (timeouts plus longs). */
export const paymentApiClient = createClient({
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

/** Uploads (pas de Content-Type par défaut pour laisser le navigateur gérer FormData). */
export const uploadApiClient = createClient({
  timeout: 30000,
});

/** Jobs scraper (timeout long — scraping async). */
export const scraperApiClient = createClient({
  headers: { 'Content-Type': 'application/json' },
  timeout: 120000,
});
